export async function loadFont() {
	const descriptors: FontFaceDescriptors = {
		display: 'swap',
	}
	const normalNotoSansSC = new FontFace(
		'Noto Sans SC',
		'url(https://cdnv2.ruguoapp.com/lsm0AG0z4-jWzHwu9q95mKQxj9Rv.ttf)',
		{
			...descriptors,
			weight: '400',
		}
	)
	const mediumNotoSansSC = new FontFace(
		'Noto Sans SC',
		'url(https://cdnv2.ruguoapp.com/ls56g-AZf_NqqrwUKz2Eny1kDLRi.ttf)',
		{
			...descriptors,
			weight: '500',
		}
	)
	const emojiFont = new FontFace(
		'Noto Color Emoji',
		'url(https://cdnv2.ruguoapp.com/lhfIFbZHptqRzOwPDi9P0WYjLTz2.ttf)',
		{
			...descriptors,
		}
	)

	await Promise.all([normalNotoSansSC.load(), mediumNotoSansSC.load(), emojiFont.load()])

	return [normalNotoSansSC, mediumNotoSansSC, emojiFont]
}
